export default __webpack_public_path__ + "static/media/dummy_thumb_2.97fa644f.png";